

import { Plus } from 'lucide-react';
import React, { useState } from 'react';
import { Button } from 'src/components/ui/button';
import { Input } from 'src/components/ui/input';
import ScreenshotterCreateInput from './screenshotter-create-input';


export type ActiveView = 'manage' | 'view';


interface MenuBarProps {
  className?: string;
  selectedClassName?: string;
  onCreated: () => void;
  activeView: ActiveView;
  searchText: string;
  onSearchChange: (text: string) => void;
  isFiltered: boolean;
  resultCount: number;
  totalCount: number;
}

const ScreenshotterMenuBar: React.FC<MenuBarProps> = ({
  className = 'bg-gray-200 text-black rounded-full',
  selectedClassName = 'bg-blue-500 text-white',
  onCreated,
  activeView = 'manage',
  searchText,
  onSearchChange,
  isFiltered,
  resultCount,
  totalCount,
}) => {
  const [search, setSearch] = useState(searchText);
  const [showCreate, setShowCreate] = useState(false);

  const handleCreated = () => {
    setShowCreate(false);
    onCreated();
  };

  return (
    <>
      <div className="flex items-center justify-between w-full">
        <div className='flex items-center gap-4 mr-2'>
          <Input
            type="text"
            placeholder="Search"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              onSearchChange(e.target.value);
            }}
            className="p-5 border-none bg-white rounded-full focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0 focus-visible:border-none w-64 text-sm shadow-none"
          />
        </div>

        <div className="flex items-center gap-3">
          <Button
            className={`${className} hover:opacity-65 ${activeView === 'view' ? selectedClassName : ''}`}
            variant="ghost"
            size="med"
            onClick={() => setShowCreate(!showCreate)}
          >
            <Plus className='w-4 h-4' />
            New
          </Button>
        </div>
      </div>
      {showCreate && (
        <ScreenshotterCreateInput onCreated={handleCreated} />
      )}
    </>
  );
};

export default ScreenshotterMenuBar;
